import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Card,
  Typography,
  TextField,
  MenuItem,
  Button,
  Divider,
  Select,
  IconButton,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  InputAdornment,
  Autocomplete,
} from "@mui/material";
import {
  Add,
  CopyAll,
  Delete,
  Numbers,
  PublishOutlined,
  Settings,
} from "@mui/icons-material";
import SendIcon from "@mui/icons-material/Send";
import { countryData, customerData, itemData } from "../../../lib/data";
import { Checkbox, ListItemText, FormControl, InputLabel } from "@mui/material";
import ApiPath from "../../../utils/api";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs"; // For date formatting
import { useDataContext } from "../../../context/Context";
import ViewInvoice from "./ViewInvoice";
// import { PublishIcon } from "@mui/icons-material";
import * as XLSX from "xlsx";
import { formatNumber } from "../../../components/formatNumber";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// import { PublishIcon } from "@mui/icons-material";

const InvoiceInterface = () => {
  const [customer, setCustomer] = useState(null); // State to store selected customer
  const [laoding, setLoading] = useState(false); // State to store selected customer
  const [imported, setImported] = useState(false); // State to store selected customer
  const [items, setItems] = useState([
    {
      name: "",
      passport: "",
      nationality: "",
      lastname: "",
      firstname: "",
      price: 0,
      quantity: 1,
    },
  ]); // State to store selected items
  const [invoiceDetails, setInvoiceDetails] = useState({
    salesperson: "",
    note: "",
    paymentMode: "",
  });
  const {
    bankTransferData,
    customer: customerData,
    PaymentMode,
    getBankTransfer,
    itemList,
    userList,
    fetchAllData,
  } = useDataContext();
  const [invoiceNumber, setInvoiceNumber] = useState(""); // State for invoice number
  const [issuedDate, setIssuedDate] = useState(""); // State for issued date
  const [dueDate, setDueDate] = useState(""); // State for due date
  const [selectedModes, setSelectedModes] = useState([]); // State to store selected payment modes
  const [amounts, setAmounts] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({}); // State
  const [preview, setPreview] = useState(false); // State
  const [previewData, setPreviewData] = useState(false); // State
  const [formErrors, setFormErrors] = useState({});
  // Available payment modes
  const [file, setFile] = useState(null);
  const [UploadedFile, setUploadedFile] = useState(null);
  const [loadingImage, setloadingImage] = useState(false);

  // const paymentModes = ["Bank", "Mobile Money", "Cash"];
  const paymentModes = PaymentMode;
  const navigate = useNavigate();
  // const [customerData, setCustData] = useState(""); // State for due date
  // const [customerData, setCustData] = useState([]); // Initialize as an empty array

  const handleFileChange = async (event) => {
    setloadingImage(true);
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;
    setFile(selectedFile);
    // Prepare the file for upload
    const formData = new FormData();
    formData.append("image", selectedFile);
    try {
      // Upload the image and wait for the response
      const response = await axios.post(
        "https://admin.tidyhub.ae/uploadsystem.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true, // Required for CORS with credentials
        }
      );
      // Extract the image URL from the response
      const imageUrl = response.data.filePath; // Match the response structure from PHP
      // Update the state with the image URL
      setUploadedFile(imageUrl);
      console.log("imageUrl", imageUrl);
      // alert("File uploaded successfully");
    } catch (error) {
      console.error("Error uploading file: ", error);
    } finally {
      // Reset the loading state
      // setloadingImage(null);
    }
    setloadingImage(false);
  };

  useEffect(() => {
    const randomInvoiceNumber = Math.floor(100000 + Math.random() * 900000); // Random 6-digit number
    setInvoiceNumber(randomInvoiceNumber);
  }, []);

  useEffect(() => {
    const randomInvoiceNumber = Math.floor(100000 + Math.random() * 900000); // Random 6-digit number
    setInvoiceNumber(randomInvoiceNumber);
    const currentDate = new Date();
    const dueDate = new Date(currentDate);
    dueDate.setDate(currentDate.getDate() + 30); // Due date 7 days from today
    // Format dates to YYYY-MM-DD for date input compatibility
    const formatDate = (date) => date.toISOString().split("T")[0];

    setIssuedDate(formatDate(currentDate));
    setDueDate(formatDate(dueDate));
  }, []);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(sheet);
      const newArrayData = parsedData
        .filter((item) => item.Type !== "Escape Report")
        .map((item, index) => ({
          // index: index,
          name:
            item["Type"] == "60 Days"
              ? "60 Days Visa | 2M Tourist A2A"
              : item["Type OP"] || item["Type"] == "1M Extension"
                ? "60 Days Visa | 2M Tourist"
                : item["Type DR"] + " " + item["Type"],

          firstname: item["First Name"], // Use bracket notation for keys with spaces
          lastname: item["Last Name"],
          passport: item["Passport No."],
          nationality: item.Nationality,
          quantity: 1,
          price: item.Debt,
        }));
      console.log("parsedData", newArrayData);
      setItems(newArrayData);
      setImported(true);
      // setImported(true);
    };
    reader.readAsBinaryString(file);
  };
  // Function to compute subtotal, tax, and total dynamically
  const calculateInvoiceTotals = () => {
    const subtotal = items.reduce(
      (acc, item) => acc + item.price * item.quantity,
      0
    );
    const tax = 0; // Example: 5% tax rate
    // const tax = subtotal; // Example: 5% tax rate
    const total = subtotal;
    return { subtotal, tax, total };
  };
  const { subtotal, tax, total } = calculateInvoiceTotals();

  const handlePreview = () => {
    const combined = [];
    // Iterate through the selectedOptions object
    for (const [mode, account] of Object.entries(selectedOptions)) {
      // Check if the mode exists in the amounts object
      if (amounts.hasOwnProperty(mode)) {
        // Add the mode, account name, and amount to the combined array
        combined.push({
          mode: mode.toLowerCase(),
          account: account?.name ? account.name.toLowerCase() : "", // Access the name property and convert to lowercase
          amount: amounts[mode], // Get the corresponding amount
        });
      }
    }
    const invoiceData = {
      invoiceNumber,
      issuedDate,
      dueDate,
      customer: {
        name: customer.FirstName + " " + customer.LastName,
        email: customer.Email,
        mobile: customer.Mobile,
      },
      items,
      subtotal,
      discount: 0,
      tax,
      total,
      salesperson: invoiceDetails.salesperson,
      note: invoiceDetails.note,
      paymentMode: combined,
    };
    setPreviewData(invoiceData);
    setPreview(!preview);
  };

  const validateForm = () => {
    const errors = {};
    items.forEach((item, index) => {
      if (!item.firstname) {
        errors[`firstname_${index}`] = "Required";
      }

      if (!item.lastname) {
        errors[`lastname_${index}`] = "Required";
      }
      if (!item.passport) {
        errors[`passport_${index}`] = "Required";
      }
      if (!item.nationality) {
        errors[`nationality_${index}`] = "Required";
      }
      if (!item.price || item.price <= 0) {
        errors[`price_${index}`] = "Required";
      }
    });
    if (!customer) {
      errors[`customer`] = "Required";
    }
    selectedModes.forEach((mode) => {
      if (!selectedOptions[mode]) {
        errors[mode] = "Option is required";
      }
      if (!amounts[mode]) {
        errors[`${mode}_amount`] = "Amount is required";
      }
    });
    return errors;
  };
  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      setLoading(false);
      return;
    }
    const combined = [];
    // Iterate through the selectedOptions object
    for (const [mode, account] of Object.entries(selectedOptions)) {
      // Check if the mode exists in the amounts object
      if (amounts.hasOwnProperty(mode)) {
        // Add the mode, account name, and amount to the combined array
        combined.push({
          mode: mode.toLowerCase(),
          account: account?._id ? account._id : "", // Access the name property and convert to lowercase
          amount: amounts[mode], // Get the corresponding amount
        });
      }
    }

    const invoiceData = {
      invoiceNumber,
      issuedDate,
      dueDate,
      customer: {
        name: customer.firstName + " " + customer.lastName,
        email: customer.email,
        mobile: customer.mobileCode + customer.mobileNumber,
      },
      items,
      subtotal,
      discount: 0,
      tax,
      total,
      salesperson: invoiceDetails.salesperson,
      note: invoiceDetails.note,
      paymentMode: combined,
      file: UploadedFile,
    };
    // console.log("...", invoiceData);
    // console.log("..invoiceData.", invoiceData);
    try {
      const response = await ApiPath.post("/invoice", invoiceData);
      console.log("Invoice saved:", response.data);
      // alert("Invoice submitted successfully!");
      message.success("Invoice Created!");
      setTimeout(() => {
        // const navigate = useNavigate();
        navigate(`/sales/view/${response.data._id}`);
        setLoading(false);
      }, 1000);
      fetchAllData();
    } catch (error) {
      console.error("Error submitting invoice:", error);
      // alert("Failed to submit invoice.");
      message.error("Failed to submit invoice!");
    }
  };

  const getBalance = () => {
    const combined = [];

    // Iterate through the selectedOptions object
    for (const [mode, account] of Object.entries(selectedOptions)) {
      // Check if the mode exists in the amounts object
      if (amounts.hasOwnProperty(mode)) {
        // Add the mode, account name, and amount to the combined array
        combined.push({
          mode: mode.toLowerCase(),
          account: account?._id ? account._id : "",
          amount: amounts[mode],
        });
      }
    }

    // Calculate the total amount with an initial value of 0
    const totalAmount = combined.reduce(
      (acc, item) => Number(acc) + Number(item.amount),
      0
    );

    // Ensure total is defined before subtraction
    // return totalAmount - (total || 0);
    return Number(total || 0) - Number(totalAmount);
  };

  const handleCustomerChange = (value) => {
    // console.log("dada", value);
    setCustomer(value); // Update selected customer
    // console.log(value);
  };

  // Function to add a new item to the invoice
  const handleAddItem = () => {
    setItems([
      ...items,
      {
        name: "",
        passport: "",
        nationality: "",
        lastname: "",
        firstname: "",
        price: 0,
        quantity: 1,
      },
    ]); // Example: Add a new item dynamically
  };

  // Function to delete an item from the invoice
  const handleDeleteItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems); // Update the items array by removing the selected item
  };

  const handleItemChange = (index, newQuantity) => {
    // console.log("newQuantity", newQuantity.ItemData);
    const newItems = [...items];
    newItems[index] = {
      ...newItems[index],
      name: newQuantity.ItemData, // Update nationality
    };
    setItems(newItems); // Update the state with the new items array
    // console.log("items", items);
  };
  const handleItemChangeImport = (index, newQuantity) => {
    // console.log("newQuantity", newQuantity.ItemData);
    const newItems = [...items];
    newItems[index] = {
      ...newItems[index],
      name: newQuantity, // Update nationality
    };
    setItems(newItems); // Update the state with the new items array
    // console.log("items", items);
  };

  const handleItemPriceChange = (index, newQuantity) => {
    const errors = validateForm();

    const updatedItems = [...items];
    updatedItems[index].price = newQuantity;
    setItems(updatedItems); // Update the quantity of the selected item
  };
  const handleFirstNamePriceChange = (index, newQuantity) => {
    const errors = validateForm();
    const updatedItems = [...items];
    updatedItems[index].firstname = newQuantity;
    setItems(updatedItems); // Update the quantity of the selected item
  };
  const handleLastNamePriceChange = (index, newQuantity) => {
    const errors = validateForm();

    const updatedItems = [...items];
    updatedItems[index].lastname = newQuantity;
    setItems(updatedItems); // Update the quantity of the selected item
  };
  const handlePassportNamePriceChange = (index, newQuantity) => {
    const updatedItems = [...items];
    updatedItems[index].passport = newQuantity;
    setItems(updatedItems); // Update the quantity of the selected item
  };

  const handleNationalityChange = (index, selectedOption) => {
    // Assume `selectedOption` is the country object with a `name` and `price`
    const newItems = [...items];
    // Update the item at the given index
    newItems[index] = {
      ...newItems[index],
      nationality: selectedOption.name, // Update nationality
    };
    setItems(newItems); // Update the state with the new items array
  };

  const handleCloneItem = (index) => {
    const clonedItem = { ...items[index] }; // Create a copy of the item
    const updatedItems = [...items, clonedItem]; // Add the cloned item to the array
    setItems(updatedItems); // Update the items array with the new cloned item
  };
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    // Convert to an array for easier handling
    const selected = typeof value === "string" ? value.split(",") : value;

    // Identify the modes being deselected
    const deselectedModes = selectedModes.filter(
      (mode) => !selected.includes(mode)
    );
    // Update the selected modes
    setSelectedModes(selected);
    // Remove amounts for deselected modes
    deselectedModes.forEach((mode) => {
      setAmounts((prevAmounts) => {
        const newAmounts = { ...prevAmounts };
        delete newAmounts[mode]; // Delete the object property for deselected mode
        return newAmounts;
      });
    });
  };

  const handleAmountChange = (mode, value) => {
    setAmounts((prev) => ({ ...prev, [mode]: value })); // Update the amount for the specified mode
  };

  const handleOptionChange = (mode, value, name) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [mode]: { _id: value, name: name }, // Store both the _id and name under the mode key
    }));
  };

  const fileInputRef = useRef(null);
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <Box style={{ padding: 20 }}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {!preview && (
            <Grid item xs={12} lg={9}>
              <Card sx={{ p: 3 }}>
                <Box p={3} borderRadius={2}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={9}>
                      <Box display="flex" alignItems="center" gap={2}>
                        <Box color="primary.main">
                          <img
                            src="https://bestoptiontravels.com/static/media/bestsv.e337dc0f8c932b77b8eef6b0d72b2442.svg"
                            height="70"
                            alt="Logo"
                          />
                        </Box>
                      </Box>
                      <Typography variant="body1">
                        Al Yasat tower, Office No 603, 6th floor,
                      </Typography>
                      <Typography variant="body1">
                        Najda Street, Abu dhabi
                      </Typography>
                      <Typography variant="body1">
                        +971 2 448 941 | +971 54 410 9635
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Typography variant="subtitle1">Invoice:</Typography>
                          <TextField
                            fullWidth
                            size="small"
                            value={invoiceNumber}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  #
                                </InputAdornment>
                              ),
                            }}
                            disabled // Disable input since it's auto-generated
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Divider sx={{ my: 3 }} />
                  <Grid container spacing={2}>
                    <Grid item xs={2}>
                      <Typography variant="subtitle1">Date Issued:</Typography>
                      <TextField
                        fullWidth
                        type="date"
                        size="small"
                        value={issuedDate}
                        onChange={(e) => setIssuedDate(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="subtitle1">Due Date:</Typography>
                      <TextField
                        fullWidth
                        size="small"
                        value={dueDate}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={4} md={4} style={{ paddingTop: 40 }}>
                      <Autocomplete
                        options={customerData}
                        getOptionLabel={
                          (option) => `${option.firstName} ${option.lastName}` // Updated field names
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Customer Name"
                            size="small"
                            placeholder="Customer Name"
                            fullWidth
                            error={!!formErrors[`customer`]}
                            helperText={formErrors[`customer`]}
                          />
                        )}
                        onChange={(event, newValue) =>
                          handleCustomerChange(newValue)
                        } // Update selected customer
                        isOptionEqualToValue={
                          (option, value) => option._id === value._id.$oid // Check ID equality for matching
                        }
                      />
                      <br />
                    </Grid>
                    <Grid item xs={4} md={4} align="right">
                      <br />
                      <Button onClick={() => handleButtonClick()}>
                        <PublishOutlined /> Import
                        <input
                          type="file"
                          accept=".xlsx, .xls, .csv"
                          onChange={handleFileUpload}
                          ref={fileInputRef}
                          style={{ display: "none" }}
                        />
                      </Button>
                    </Grid>
                  </Grid>

                  <Divider sx={{ my: 1 }} />
                  <form>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={0.3}>
                        <Typography variant="subtitle1">#</Typography>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle1">Item</Typography>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle1">First Name</Typography>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle1">Last Name</Typography>
                      </Grid>
                      <Grid item xs={12} md={1.5}>
                        <Typography variant="subtitle1">
                          Passport No.
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Typography variant="subtitle1">Nationality</Typography>
                      </Grid>
                      <Grid item xs={12} md={1}>
                        <Typography variant="subtitle1">Price</Typography>
                      </Grid>
                      <Grid item xs={12} md={1}></Grid>
                    </Grid>
                    <br />
                    <div style={{ height: "30vh", overflow: "auto" }}>
                      {items.map((item, index) => (
                        <Box mb={3} key={index}>
                          <Box display="flex" borderRadius={2}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={0.3}>
                                {index + 1}
                              </Grid>
                              <Grid item xs={12} md={2}>
                                {imported ? (
                                  <TextField
                                    type="text"
                                    value={item.name}
                                    onChange={(e) =>
                                      handleItemChangeImport(
                                        index,
                                        e.target.value
                                      )
                                    } // Handle price change
                                    size="small"
                                    placeholder="Item"
                                    fullWidth
                                    required
                                  />
                                ) : (
                                  <Autocomplete
                                    options={itemList}
                                    getOptionLabel={(option) =>
                                      `${option.ItemData}`
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Select Item"
                                        size="small"
                                        placeholder="Select Item"
                                        fullWidth
                                      />
                                    )}
                                    onChange={(e, data) =>
                                      handleItemChange(index, data)
                                    }
                                    isOptionEqualToValue={(option, value) =>
                                      option.ItemData === value.ItemData
                                    }
                                    value={itemList.find(
                                      (country) =>
                                        country.ItemData === item.item
                                    )}
                                  />
                                )}
                              </Grid>
                              <Grid item xs={12} md={2}>
                                <TextField
                                  type="text"
                                  value={item.firstname}
                                  onChange={(e) =>
                                    handleFirstNamePriceChange(
                                      index,
                                      e.target.value
                                    )
                                  } // Handle price change
                                  size="small"
                                  placeholder="First Name"
                                  fullWidth
                                  error={!!formErrors[`firstname_${index}`]}
                                  helperText={formErrors[`firstname_${index}`]}
                                  required
                                />
                              </Grid>
                              <Grid item xs={12} md={2}>
                                <TextField
                                  type="text"
                                  value={item.lastname}
                                  onChange={(e) =>
                                    handleLastNamePriceChange(
                                      index,
                                      e.target.value
                                    )
                                  } // Handle price change
                                  size="small"
                                  placeholder="Last Name"
                                  error={!!formErrors[`lastname_${index}`]}
                                  helperText={formErrors[`lastname_${index}`]}
                                  fullWidth
                                  required
                                />
                              </Grid>
                              <Grid item xs={12} md={1.5}>
                                <TextField
                                  type="text"
                                  value={item.passport}
                                  onChange={(e) =>
                                    handlePassportNamePriceChange(
                                      index,
                                      e.target.value
                                    )
                                  } // Handle price change
                                  size="small"
                                  placeholder="Passport No."
                                  error={!!formErrors[`passport_${index}`]}
                                  helperText={formErrors[`passport_${index}`]}
                                  fullWidth
                                  required
                                />
                              </Grid>
                              <Grid item xs={12} md={2}>
                                <Autocomplete
                                  options={countryData}
                                  getOptionLabel={(option) => `${option.name}`}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Nationality"
                                      size="small"
                                      placeholder="Select Nationality"
                                      fullWidth
                                      error={
                                        !!formErrors[`nationality_${index}`]
                                      }
                                      helperText={
                                        formErrors[`nationality_${index}`]
                                      }
                                    />
                                  )}
                                  onChange={(event, selectedOption) =>
                                    handleNationalityChange(
                                      index,
                                      selectedOption
                                    )
                                  }
                                  isOptionEqualToValue={(option, value) =>
                                    option.name === value.name
                                  }
                                  value={
                                    countryData.find(
                                      (country) =>
                                        country.name === item.nationality
                                    ) || null
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={1}>
                                <TextField
                                  type="number"
                                  value={item.price}
                                  onChange={(e) =>
                                    handleItemPriceChange(index, e.target.value)
                                  } // Handle price change
                                  size="small"
                                  placeholder="Price"
                                  fullWidth
                                  error={!!formErrors[`price_${index}`]}
                                  helperText={formErrors[`price_${index}`]}
                                />
                              </Grid>

                              <Grid item xs={12} md={1}>
                                <Box
                                  display="flex"
                                  justifyContent="flex-end"
                                  alignItems="flex-end"
                                  height="100%"
                                >
                                  <Tooltip title="Remove Item">
                                    <IconButton
                                      onClick={() => handleCloneItem(index)}
                                    >
                                      <CopyAll />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Remove Item">
                                    <IconButton
                                      onClick={() => handleDeleteItem(index)}
                                    >
                                      <Delete />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>
                      ))}
                    </div>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={handleAddItem} // Add new item
                      startIcon={<Add />}
                    >
                      Add Item
                    </Button>
                  </form>
                  <Divider sx={{ my: 3 }} />
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                      <Autocomplete
                        options={userList}
                        getOptionLabel={(option) =>
                          `${option.LastName}  ${option.FirstName}`
                        }
                        sx={{ textTransform: "uppercase" }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Sale Person"
                            size="small"
                            placeholder="Sale Person"
                            fullWidth
                          />
                        )}
                        // onChange={handleCustomerChange} // Update selected customer
                        onChange={(e) =>
                          setInvoiceDetails((prev) => ({
                            ...prev,
                            salesperson: e.target.value,
                          }))
                        }
                        isOptionEqualToValue={(option, value) =>
                          option._id === value._id
                        }
                      />
                      <br />
                      <br />
                      <br />
                      <div>
                        <Typography variant="h5">Invoice to :</Typography>
                        <Divider sx={{ my: 3 }} />

                        <Typography>
                          {customer?.firstName} {customer?.lastName}
                        </Typography>
                        <Typography>{customer?.email}</Typography>
                        <Typography>{customer?.mobileNumber}</Typography>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Note"
                        size="small"
                        value={invoiceDetails.note}
                        onChange={(e) =>
                          setInvoiceDetails((prev) => ({
                            ...prev,
                            note: e.target.value,
                          }))
                        }
                      />
                    </Grid>

                    <Grid item xs={12} lg={4}>
                      <Card sx={{ p: 3 }}>
                        <TableContainer>
                          <Table>
                            <TableBody>
                              <TableRow>
                                <TableCell>Subtotal</TableCell>
                                <TableCell align="right">
                                  {subtotal.toFixed(2)} AED
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>Tax</TableCell>
                                <TableCell align="right">
                                  {tax.toFixed(2)} AED
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>Total</TableCell>
                                <TableCell align="right">
                                  {total.toFixed(2)} AED
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              </Card>
            </Grid>
          )}
          {preview && (
            <Grid item xs={12} lg={9}>
              <ViewInvoice data={previewData} />
            </Grid>
          )}
          {/* Actions Section */}
          <Grid item xs={12} lg={3}>
            {loadingImage ? (
              <span>Uploading image....</span>
            ) : (
              <Button
                variant="outlined"
                component="label"
                fullWidth
                style={{ marginTop: "16px", marginBottom: "16px" }}
              >
                Attach Document
                <input type="file" hidden onChange={handleFileChange} />
              </Button>
            )}
            <div>
              {/* {UploadedFile} */}
              <div align="center">
                {UploadedFile && (
                  <img
                    src={UploadedFile}
                    alt="Uploaded File"
                    style={{ width: "140px", height: "auto" }}
                  />
                )}
              </div>
            </div>
            <Card sx={{ p: 3 }}>
              {laoding ? (
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  startIcon={<SendIcon />}
                  sx={{ mb: 2 }}
                  style={{
                    background: "red",
                    opacity: 0.3,
                    cursor: "not-allowed",
                  }}
                >
                  Please Wait ....
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  startIcon={<SendIcon />}
                  sx={{ mb: 2 }}
                  type="submit"
                  style={{ background: "green" }}
                >
                  SUBMIT INVOICE
                </Button>
              )}
              {/* <Button
                variant="contained"
                color="primary"
                fullWidth
                startIcon={<SendIcon />}
                sx={{ mb: 2 }}
                type="submit"
              >
                Send Invoice
              </Button> */}
              <Button
                variant="outlined"
                fullWidth
                // startIcon={<Preview />}
                sx={{ mb: 2 }}
                onClick={() => handlePreview()}
              >
                Preview
              </Button>
              {/* <Button variant="outlined" fullWidth>
                Save
              </Button> */}
            </Card>
            <br /> <br />
            <Typography>Select Payment Modes</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {!preview && (
                  <FormControl fullWidth style={{ marginTop: 15 }}>
                    <Select
                      multiple
                      value={selectedModes}
                      onChange={handleChange}
                      size="small"
                      renderValue={(selected) => selected.join(", ")} // Display selected values as comma-separated
                    >
                      {PaymentMode.map(({ mode }) => (
                        <MenuItem key={mode} value={mode}>
                          <Checkbox
                            checked={selectedModes.indexOf(mode) > -1}
                          />
                          <ListItemText
                            primary={mode}
                            style={{ textTransform: "capitalize" }}
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Grid>
              {selectedModes.map((mode) => {
                // Find mode and corresponding options from PaymentMode
                const { options } =
                  PaymentMode.find((m) => m.mode === mode) || {};

                return (
                  <Grid container item xs={12} spacing={1} key={mode}>
                    <Grid
                      item
                      xs={4}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Typography
                        variant="body1"
                        style={{ textTransform: "capitalize" }}
                      >
                        {mode}:
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      {options && options.length > 0 && (
                        <FormControl fullWidth required>
                          <Autocomplete
                            options={options}
                            getOptionLabel={(subOption) =>
                              `${subOption.name} (Account: ${subOption.account})`
                            }
                            onChange={(event, newValue) => {
                              handleOptionChange(
                                mode,
                                newValue ? newValue._id : "",
                                newValue ? newValue.name : ""
                              );
                            }} // Update selected option
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Option"
                                size="small"
                                variant="outlined"
                                required
                              />
                            )}
                            value={
                              options.find(
                                (subOption) =>
                                  subOption._id === selectedOptions[mode]?._id
                              ) || null
                            }
                            isOptionEqualToValue={(option, value) =>
                              option._id === value._id
                            } // Comparison function by _id
                            fullWidth
                          />
                        </FormControl>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        size="small"
                        type="number"
                        placeholder="Enter amount"
                        value={amounts[mode] || ""} // Controlled input for amount
                        onChange={(e) =>
                          handleAmountChange(mode, e.target.value)
                        } // Update amount
                        style={{ width: "100%" }} // Full width
                        required
                      />
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
            <br />
            <div>
              Balance :{" "}
              <span style={{ color: "red", fontWeight: "bold" }}>
                {formatNumber(getBalance())}
              </span>{" "}
              AED
            </div>
            <br />
            <br />
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default InvoiceInterface;
